
import axios from "axios";
import { ErroMsg, cleanJsonString } from "../../frontend/contents/VariaveisGlobais";

async function ConsumoTOTVS_POST( rota, json, cEmpresaFilial ){
    const URLRest = window._env_?.REACT_APP_URL_REST + rota;
    const Token = window._env_?.REACT_APP_TOKEN_REST;
    const EmpFilLogado = cEmpresaFilial ? cEmpresaFilial : localStorage.getItem('empresaFilial');
    const EmpresaParam = EmpFilLogado.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA);
    const FilialParam = EmpFilLogado.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL);

    // useEffect(() => {
        var lista = await axios.post( URLRest, json, {
            headers: {
                "tenantId": EmpresaParam + ',' + FilialParam,
                "Content-Type": "application/json",
                'Authorization': `Basic ${Token}`,
                "Accept" : "*/*",
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
            }})
            .then((response) => {
                let responseData = response.data
                
                if (typeof responseData == 'string'){
                    responseData = JSON.parse(cleanJsonString(responseData))
                }
                
                return responseData;
            })
            .catch((err) => {
                ErroMsg('Falha ao Processar! ' +  err.message)
                return {error: "01", description:"Falha ao Processar!" + err, data: []};
            });
    // }, []);

    return lista;
}

export default ConsumoTOTVS_POST